import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addListingDetailsType } from '~addListing/types';

const Area = () => {
  const { t } = useTranslation('app');
  const {
    setValue,
    clearErrors,
    formState: { errors },
    watch,
  } = useFormContext<addListingDetailsType>();

  return (
    <div className="flex flex-col gap-1.5x">
      <p className="text-title_4 text-black">
        {t('area')} ({t('byMeter')})
      </p>
      <div
        className={`${errors['area'] ? 'border-red_dark' : 'border-gray'} flex gap-2x border  rounded-[12px] px-1.5x py-x items-center h-[40px] focus-within:border-blue_light_1`}
      >
        <input
          type="number"
          placeholder={t('areaPlaceholder')}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (value >= 0) setValue('area', value);
            else setValue('area', 0);
          }}
          min={0}
          defaultValue={`${watch('area')}` !== '0' ? watch('area') : ''}
          onFocus={() => clearErrors('area')}
          className="flex-1 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]"
          onWheel={(e) => (e.target as HTMLInputElement).blur()}
        />
        <p className="border-s ps-x border-gray">{t('meter')}</p>
      </div>
      {errors['area'] && <p className="text-red_dark">{t('areaRequired')}</p>}
    </div>
  );
};

export default Area;
